import { render, staticRenderFns } from "./SalePageUnPublishButton.vue?vue&type=template&id=3b8a9c88&scoped=true&"
import script from "./SalePageUnPublishButton.vue?vue&type=script&lang=js&"
export * from "./SalePageUnPublishButton.vue?vue&type=script&lang=js&"
import style0 from "./SalePageUnPublishButton.vue?vue&type=style&index=0&id=3b8a9c88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8a9c88",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog,VIcon,VListItem,VListItemSubtitle,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b8a9c88')) {
      api.createRecord('3b8a9c88', component.options)
    } else {
      api.reload('3b8a9c88', component.options)
    }
    module.hot.accept("./SalePageUnPublishButton.vue?vue&type=template&id=3b8a9c88&scoped=true&", function () {
      api.rerender('3b8a9c88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SalePage/components/SalePageUnPublishButton.vue"
export default component.exports